import buildingService from '../../services/buildingService';
import axios from 'axios';

// initial state
const state = {
  building:{}
}

// getters
const getters = {
}

// actions
const actions = {
    getBuilding(context,id){
      return new Promise((resolve,reject)=>{
        const buildingPromise = buildingService.getById(id);
        buildingPromise
        .then((resp) => {
          context.commit('set_building', resp.data)
          resolve(resp)
        })
        .catch(err => {
          // context.commit('auth_error')
          reject(err)
        })
      })
    }
}

// mutations
const mutations = {
    set_building(state,response) {
      state.building = response
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}